<template lang="pug">
  .el-main
    img.logo(:src="images.logo")
    .login
      el-form(label-position="top" label-width="100px" ref="form" :model="form")
        el-form-item(:label="$t('sign_in.email')" prop="email" clearable="")
          el-input(v-model="form.email")
        el-form-item(:label="$t('sign_in.password')" prop="password")
          el-input(v-model="form.password" type="password" clearable="")
      el-row(type="flex" justify="center")
        el-button(type="primary" @click="signIn" :loading="signInLoading") {{ $t('sign_in.signin') }}
      el-row
        el-menu.options
          el-menu-item(index="1" style="padding-left:0;")
            router-link(:to="{name:'forgot'}") {{ $t('sign_in.forgot_password') }}
    el-row(type="flex" justify="center")
      el-menu(mode="horizontal")
        el-menu-item(index="1")
          a(href="/terms") {{ $t('footer_menus.terms') }}
        el-menu-item(index="2")
          a(href="/privacy") {{ $t('footer_menus.privacy') }}
        el-menu-item(index="3")
          a(href="https://cuona.io/contact") {{ $t('footer_menus.contact') }}

</template>

<script>
import API from '@/api/auth'

export default {
  data() {
    return {
      signInLoading: false,
      form: {
        email: '',
        password: ''
      },
      images: {
        logo: require('@/assets/cuona_logo.svg')
      }
    }
  },
  methods: {

    // バリデーション
    validate: function(){
      var error = false
      var email = this.form.email
      var pass  = this.form.password

      if (email.length == 0){
        error = true
      }
      if (!this.validateEmail(email)){
        error = true
      }
      if (pass.length < 6){
        error = true
      }
      return error
    },

    // エラー
    signin_error: function(errorCode){
      switch(errorCode) {
        case 401:
          this.$message({ showClose: true, message: this.$t('sign_in.signin_error'), type: 'error' })
          break
        case 403:
          this.$message({ showClose: true, message: this.$t('sign_in.activation_error'), type: 'error' })
          break
      }
      this.signInLoading = false
    },

    // サインイン
    signIn: function()
    {
      this.signInLoading = true
      if (this.validate()) {
        this.signin_error(401)
        return
      }

      let params = {
        email: this.form.email,
        password: this.form.password
      }
      return this.$store.dispatch('signIn', params)
        .then(() => {
          this.$message({ showClose: true, message: this.$t('sign_in.signin_success'), type: 'success' })
          this.signInLoading = false
          this.$router.replace('/dashboard')
        }).catch((error) => {
          this.signin_error(error.status)
        })
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

.el-main {
  height: 100vh;

  img.logo {
    display: block;
    margin: 10px auto 30px auto;
    width: 130px;
  }

  .login {
    background: #FFF;
    border-radius: 5px;
    border: 1px solid $border;
    margin: 0 auto;
    padding: 30px 40px 40px 40px;
    width: 300px;

    .el-button {
      width: 100%;
      padding: 18px 0;
      font-size: 22px;
      margin-top: 20px;
    }
  }
}

.options {
  border: none;
  margin-top: 10px;
  li {
    padding: 0;
    line-height: 30px;
    height: 30px;

    a {
      transition: all .3s ease-in-out;
    }

    &:hover {
      background: inherit !important;
      a {
        color: $safe;
      }
    }
  }
}

.el-menu.el-menu--horizontal {
  border-bottom: none;
  background: inherit;
  li {
    line-height: 40px;
    height: 40px;
    color: #AAA;
    &:hover {
      background: inherit !important;
    }
  }
}

.el-form--label-top ::v-deep {
  .el-form-item__label {
    padding: 0;
    line-height: 30px;
    color: #999;
  }
}

</style>
